import {
   ACCIDENT_PARTIES_AT_FAULT_OPTIONS,
   ACCIDENT_TYPE_OPTIONS, CONVICTION_CODES,
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST, DRIVING_LICENSE_TYPE_OPTIONS, EMPLOYMENT_STATUS_OPTIONS,
   relationshipsWithPolicyMaker,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";
import {isBefore, isSameDay, isValid, parse, subYears} from "date-fns";
import {
   isDateGreaterThanNow,
   isEmptyString,
   isInLabelValueArray,
   isInLabelValueArrayAsString,
   isValidDateTimeString, isValidPositiveNumber
} from "@utils/validators";
import {isDateGreaterThenToday} from "@utils/date-time";
import {validateAdditionalDrivers} from "@validators/common/sub-components/validate-additional-drivers";


export const ValidateStep5Data = (data) => {
   
   let msgList = [/*{
        name: 'halt',
        message: 'Halt'
    }*/];
   
   validateAdditionalDrivers({
      data,
      msgList
   })
   
   return msgList;
   
}